import { jsx as _jsx, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { subscribe, unsubscribe } from '@stepstone/events-js';
import { getSubscriptionEvents, getUpdateFunctionsCustomEvent, getUpdateFunctionsPubSub, } from './eventsSubscriptions.js';
import { DialogWrapper } from '../../components/DialogWrapper/index.js';
import { activeModalTypeSelector, closeModalThunk, isGDPRModalActiveSelector, } from './modalSlice.js';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/index.js';
import { sendGlobalTrackingThunk } from '../../core/thunks.js';
import { removeDynamicGlobalTrackingLibraryScript } from '../../tools/tracking.js';
import { trackingResetPasswordStateSelector } from '../../forms/ResetPassword/resetPasswordSlice.js';
import { trackButtonClick } from '../../tracking/index.js';
import { encodedGTLibraryUrlSelector, logoBrandNameSelector, } from '../../core/siteConfig/siteConfigSlice.js';
import { twoStepActiveStateSelector, trackingTwoStepLoginRegistrationStateSelector, } from '../../forms/TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
import { modalNavigationMiddleware } from './modalNavigationMiddleware.js';
import { pageNavigationMiddleware } from '../Page/pageNavigationMiddleware.js';
import { useConsentLevelSubscriber } from '../../hooks/useConsentLevelSubscriber.js';
import { useOptimizelyExperiment } from '../../features/optimizely/useOptimizelyExperiment.js';
import { TwoStepModalExperimentKey } from '../../features/optimizely/allExperiments/twoStepModal.js';
import { useGDPRModalActive } from '../../hooks/useGDPRModalActive.js';
import { modalFormConfigs } from './modalFormConfigs.js';
import { showRegistrationSuccessfulModalSelector } from '../../forms/Registration/registrationSlice.js';
import CVUploadModal from '../../components/RegistrationSuccessModal/index.js';
import { isTwoStep } from '../../tracking/helpers/constants.js';
export const Modal = () => {
    const dispatch = useAppDispatch();
    const activeModalType = useAppSelector(activeModalTypeSelector);
    const resetPasswordComponentState = useAppSelector(trackingResetPasswordStateSelector);
    const encodedGTLibraryUrl = useAppSelector(encodedGTLibraryUrlSelector);
    const logoBrandName = useAppSelector(logoBrandNameSelector);
    const twoStepModalComponentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    const twoStepModalExperimentVariant = useOptimizelyExperiment(TwoStepModalExperimentKey);
    const isGDPRModalActive = useAppSelector(isGDPRModalActiveSelector);
    const showRegistrationSuccessfulModal = useAppSelector(showRegistrationSuccessfulModalSelector);
    const activeTwoStepState = useAppSelector(twoStepActiveStateSelector);
    useConsentLevelSubscriber();
    useGDPRModalActive();
    // todo move this logic somewhere else
    const hideModal = () => {
        if (activeModalType === 'resetPassword') {
            dispatch(sendGlobalTrackingThunk(trackButtonClick, {
                componentState: resetPasswordComponentState,
                uniqueName: 'modalClose',
            }));
        }
        else if ((activeTwoStepState === 'resetPassword' ||
            activeTwoStepState === 'resetPasswordSuccess') &&
            isTwoStep(activeModalType)) {
            dispatch(sendGlobalTrackingThunk(trackButtonClick, {
                componentState: resetPasswordComponentState,
                uniqueName: 'modalClose',
            }));
        }
        else if (isTwoStep(activeModalType)) {
            dispatch(sendGlobalTrackingThunk(trackButtonClick, {
                componentState: twoStepModalComponentState,
                uniqueName: 'modalClose',
            }));
        }
        else {
            dispatch(sendGlobalTrackingThunk(trackButtonClick, {
                uniqueName: 'modalClose',
            }));
        }
        modalNavigationMiddleware.remove();
        pageNavigationMiddleware.resume();
        removeDynamicGlobalTrackingLibraryScript();
        dispatch(closeModalThunk());
    };
    const updateFunctions = getUpdateFunctionsCustomEvent(encodedGTLibraryUrl, logoBrandName, dispatch);
    const updateFunctionsPubSub = getUpdateFunctionsPubSub(encodedGTLibraryUrl, logoBrandName, dispatch);
    const eventsToSubscribe = getSubscriptionEvents({
        ...updateFunctions,
        hideModal,
    });
    const eventsToSubscribePubSub = getSubscriptionEvents({
        ...updateFunctionsPubSub,
        hideModal,
    });
    useEffect(() => {
        eventsToSubscribe.map((event) => {
            subscribe(event.eventName, event.updateFunction);
        });
        if ('PubSub' in window) {
            eventsToSubscribePubSub.map((event) => {
                window.PubSub.subscribe(event.eventName, event.updateFunction);
            });
        }
        return () => {
            eventsToSubscribe.map((event) => {
                unsubscribe(event.eventName, event.updateFunction);
            });
            if ('PubSub' in window) {
                eventsToSubscribePubSub.map((event) => {
                    window.PubSub.unsubscribe(event.eventName);
                });
            }
        };
    });
    const modalForms = modalFormConfigs(twoStepModalExperimentVariant);
    if (showRegistrationSuccessfulModal) {
        return _jsx(CVUploadModal, {});
    }
    return (_jsx(_Fragment, { children: modalForms.map(({ component, type, fullscreenModal }) => {
            const FormComponent = component;
            return (_jsx(DialogWrapper, { hideModal: hideModal, isModalVisible: activeModalType === type && !isGDPRModalActive, modalType: type, fullscreenModal: fullscreenModal, children: _jsx(FormComponent, {}) }, type));
        }) }));
};
//# sourceMappingURL=Modal.js.map